import { render } from "./EditEmergency.vue?vue&type=template&id=3486dc4b&scoped=true"
import script from "./EditEmergency.vue?vue&type=script&lang=js"
export * from "./EditEmergency.vue?vue&type=script&lang=js"

import "./EditEmergency.vue?vue&type=style&index=0&id=3486dc4b&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3486dc4b"]])

export default __exports__